import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import LoginView from "@/views/LoginView.vue";
import { useQuery, useResult } from "@vue/apollo-composable";
import { computed, reactive } from "vue";
import { SessionDocument } from "./generated/graphql";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const sessionQuery = useQuery(SessionDocument);
const session = useResult(sessionQuery.result);

const sw = reactive({
  registration: undefined as undefined | ServiceWorkerRegistration,
  updateExists: false,
  reloading: false,
});
const version = computed(() => process.env.VUE_APP_VERSION);

document.addEventListener(
  "swUpdated",
  ((event: CustomEvent<ServiceWorkerRegistration>) => {
    sw.registration = event.detail;
    sw.updateExists = true;
    // eslint-disable-next-line no-undef
  }) as EventListener,
  { once: true }
);
navigator.serviceWorker.addEventListener("controllerchange", () => {
  if (sw.reloading) return;
  sw.reloading = true;
  window.location.reload();
});

function update() {
  sw.updateExists = false;
  if (!sw.registration?.waiting) return;
  sw.registration.waiting.postMessage({ type: "SKIP_WAITING" });
}

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_unref(session)?.active)
      ? (_openBlock(), _createBlock(LoginView, {
          key: 0,
          query: _unref(sessionQuery)
        }, null, 8, ["query"]))
      : (_openBlock(), _createBlock(_component_router_view, { key: 1 })),
    _createElementVNode("div", {
      class: "text-center text-gray mt-4 mb-2",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (update()))
    }, [
      _createElementVNode("span", null, "v" + _toDisplayString(_unref(version)), 1),
      (_unref(sw).updateExists)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, " - Update verfügbar"))
        : _createCommentVNode("", true),
      (_unref(sw).reloading)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, " - Aktualisieren..."))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})